import { FLOW_TYPE } from "../../constants/variables";
import { Logger } from "./logger";

export enum EventType {
  EVENT,
  SUCCESS,
  FAIL
}

export async function loggingUserActivities(
  object: any,
  flowType: string = FLOW_TYPE.CHECK_IN,
  eventType: EventType = EventType.EVENT,
  pnr: string | null = null,
  exception: Error | null = null
) {
  const message = object;
  if (eventType === EventType.SUCCESS || eventType === EventType.FAIL) {
    Logger.Instance.end(flowType, message, pnr, exception);
  } else {
    Logger.Instance.log(flowType, message, exception);
  }
}
